import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import logoImg from "../assets/logo.png";
import { getCityUrl } from "../constants";
import { getContent, getLocalContent, getSeoSettings, getLocalSeoSettings } from "../api";

const Footer = () => {
  const [content, setContent] = useState(() => getLocalContent());
  const [seo, setSeo] = useState(() => getLocalSeoSettings());
  const year = new Date().getFullYear();

  useEffect(() => {
    getContent().then((data) => { if (data) setContent(data); }).catch(() => {});
    getSeoSettings().then((data) => { if (data) setSeo(data); }).catch(() => {});
  }, []);

  const siteName = seo?.siteName || "Mini Golf Alabama";
  const siteDomain = seo?.siteUrl ? seo.siteUrl.replace(/^https?:\/\//, "").replace(/\/$/, "") : "minigolfalabama.com";
  const tagline = content?.footerTagline || `${siteName} (${siteDomain}) is your #1 guide to finding the best indoor and outdoor mini golf putt putt courses in Alabama and across the United States.`;
  const description = content?.footerDescription || "Discover top family fun parks, birthday venues, date night spots & glowing blacklight courses.";
  const copyright = content?.copyrightText || `${siteName} (${siteDomain}). All rights reserved.`;

  return (
    <footer className="bg-[#111217] text-gray-400 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
          {/* Brand Info */}
          <div>
            <Link to="/" className="inline-block mb-4">
              <img src={seo?.logoUrl || logoImg} alt={siteName} className="h-12 w-auto object-contain" />
            </Link>
            <p className="text-sm text-gray-400 leading-relaxed mb-4">
              {tagline}
            </p>
            <div className="text-xs text-gray-500">
              {description}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-bold text-white uppercase tracking-wider mb-4 border-l-2 border-[#e5243b] pl-2.5">
              Quick Links
            </h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/state/alabama" className="text-gray-300 hover:text-[#e5243b] transition-colors flex items-center gap-1.5">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#e5243b]"></span>
                  Alabama Mini Golf Courses
                </Link>
              </li>
              <li>
                <Link to="/courses" className="hover:text-white transition-colors">
                  All Courses Directory
                </Link>
              </li>
              <li>
                <Link to="/states" className="hover:text-white transition-colors">
                  All 50 States
                </Link>
              </li>
              <li>
                <Link to="/top-rated" className="hover:text-white transition-colors">
                  Top Rated Courses
                </Link>
              </li>
              <li>
                <Link to="/blog" className="hover:text-white transition-colors">
                  Blog & Guides
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-white transition-colors">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-and-conditions" className="hover:text-white transition-colors">
                  Terms & Conditions
                </Link>
              </li>
            </ul>
          </div>

          {/* Alabama Hotspots */}
          <div>
            <h3 className="text-sm font-bold text-white uppercase tracking-wider mb-4 border-l-2 border-[#2563eb] pl-2.5">
              Alabama Locations
            </h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to={getCityUrl("al", "Birmingham")} className="hover:text-white transition-colors">
                  Birmingham Putt Putt
                </Link>
              </li>
              <li>
                <Link to={getCityUrl("al", "Huntsville")} className="hover:text-white transition-colors">
                  Huntsville Miniature Golf
                </Link>
              </li>
              <li>
                <Link to={getCityUrl("al", "Mobile")} className="hover:text-white transition-colors">
                  Mobile Mini Golf
                </Link>
              </li>
              <li>
                <Link to={getCityUrl("al", "Orange Beach")} className="hover:text-white transition-colors">
                  Orange Beach Courses
                </Link>
              </li>
              <li>
                <Link to={getCityUrl("al", "Tuscaloosa")} className="hover:text-white transition-colors">
                  Tuscaloosa Mini Golf
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-gray-500">
          <p>
            © {year} <span className="text-gray-300 font-semibold">{copyright}</span>
          </p>
          <div className="flex items-center gap-4 flex-wrap">
            <Link to="/about" className="hover:text-gray-300 transition-colors">
              About Us
            </Link>
            <span className="text-gray-700">·</span>
            <Link to="/contact" className="hover:text-gray-300 transition-colors">
              Contact Us
            </Link>
            <span className="text-gray-700">·</span>
            <Link to="/privacy-policy" className="hover:text-gray-300 transition-colors">
              Privacy Policy
            </Link>
            <span className="text-gray-700">·</span>
            <Link to="/terms-and-conditions" className="hover:text-gray-300 transition-colors">
              Terms & Conditions
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
